import { Button } from 'components/atoms';
import { Form } from 'components/organisms';
import { FormikHelpers } from 'formik';
import { useParamId } from 'hooks/useParamId';
import middleware from 'middleware';
import { useTranslation } from 'react-i18next';
import { PiX } from 'react-icons/pi';
import { useNavigate } from 'react-router-dom';
import {
  useGetSectionTemplate,
  usePutSectionTemplate,
} from 'services/templates/section-template';
import { IContractTemplateForm } from 'services/templates/types';
import { BUTTON_VARIANT } from 'types/components/button/button.interface';
import { contractTemplateUtil } from 'utils';
import { onErrorShowAllErrorsToast } from 'utils/service/errorHandler';

const EditCustomSectionTemplate = () => {
  const id = useParamId('/templates-extended');
  const { t } = useTranslation();
  const navigate = useNavigate();

  const sectionTemplate = useGetSectionTemplate(id);

  const updateSectionTemplate = usePutSectionTemplate();

  const goBackToSection = () => navigate(`/templates-extended/section/${id}/form`);

  const onUpdateSectionTemplate = async (
    values: IContractTemplateForm,
    formikHelpers: FormikHelpers<IContractTemplateForm>
  ) => {
    await updateSectionTemplate.mutateAsync(
      {
        customSectionTemplateId: id,
        customSectionTemplate: middleware.template.section.formToQuery(values),
      },
      {
        onSuccess: goBackToSection,
        onError: error => onErrorShowAllErrorsToast(error),
      }
    );
  };
  return (
    <Form.Contract
      tittle={`${t('button.edit')} ${
        sectionTemplate.data?.title ?? t('contract-template.section.title')
      }`}
      customBackItem={
        <Button type='button' onlyIcon onClick={goBackToSection}>
          <Button.Icon icon={<PiX />} />
        </Button>
      }
      topbarContent={
        <>
          <Button type='submit' variant={BUTTON_VARIANT.submit}>
            <Button.Text text={t(`button.save`)} />
          </Button>
        </>
      }
      initialStatus={contractTemplateUtil.section.initialStatus}
      initialValues={{
        ...contractTemplateUtil.form.initialValues,
        items: sectionTemplate.data
          ? middleware.template.section.queryToForm(sectionTemplate.data)
          : contractTemplateUtil.section.initialValues(),
      }}
      onSubmit={onUpdateSectionTemplate}
      status={{ isLoading: sectionTemplate.isLoading }}
    />
  );
};

export default EditCustomSectionTemplate;
